export const plansAndCreditsHeroPlans = [
  { id: 1, numberOfCredits: 8, price: 19 },
  { id: 2, numberOfCredits: 16, price: 39 },
  { id: 3, numberOfCredits: 20, price: 69 },
];

export const plansAndCreditsHeroListItems = [
  "BookClassesAppointments",
  "AdjustOrCancelYourPlanAtAnyTime",
  "InviteFriendsToJoinYou",
];

export const plansAndCreditsWaysToSpend = [
  { id: 1, text: "CreditsCanBeUsedToBookAClassOrAppointment" },
  { id: 2, text: "TheNumberOfCreditsNeededToBook" },
  { id: 3, text: "YouCanAlwaysAddCreditsAndAdjust" },
];
